"use strict";
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const theme_1 = require("../../theme");
/**
 * `Layout` container component. Behaves like React Native `View`.
 * The key feature of using `Layout` instead of `View` is that
 * it automatically picks background color fitting to current theme.
 *
 * @extends React.Component
 *
 * @property {string} level - Determines background color level of component.
 * Can be `'1'`, `'2'`, `'3'` or `'4'`.
 * Default is `'1'`.
 *
 * @property {ReactElement | ReactElement[]} children - Determines the children of the component.
 *
 * @property {ViewProps} ...ViewProps - Any props applied to View component.
 *
 * @overview-example LayoutSimpleUsage
 *
 * @overview-example LayoutLevel
 *
 * @example LayoutInlineStyling
 */
class LayoutComponent extends react_1.default.Component {
    render() {
        const { style, themedStyle, ...derivedProps } = this.props;
        return (react_1.default.createElement(react_native_1.View, Object.assign({}, derivedProps, { style: [themedStyle, style] })));
    }
}
exports.LayoutComponent = LayoutComponent;
LayoutComponent.styledComponentName = 'Layout';
exports.Layout = theme_1.styled(LayoutComponent);
//# sourceMappingURL=layout.component.js.map